import { useQuery } from 'react-query';
import { useAPI } from '@axo/shared/data-access/provider';
import { ace_api } from '@axo/shared/data-access/api';
import { bucketsKeys } from '../../cache-keys/bucketsKeys';

export function useBucketSummaries() {
  const api = useAPI();

  return useQuery({
    queryKey: [bucketsKeys.bucketSummaries()],
    queryFn: ace_api.getBucketSummaries(api),
    enabled: api.token !== '',
  });
}
